export const IllegalDrugActivityTypeConstants = {
  USED: 'used',
  SOLD: 'sold',
  PRESENT: 'present'
}
